module.exports = __webpack_public_path__ + "static/segmented-timeline-366ef08a5926a6d679671e3fbee8c88a.webp";